<template>
  <div>
    <v-list>
      <v-list-item-group v-model="model">
        <v-list-item v-for="(item, i) in items" :key="i" three-line>
          <v-list-item-icon>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="item.title"></v-list-item-title>
            <v-list-item-subtitle v-text="item.sub"></v-list-item-subtitle>
            <v-list-item-subtitle
              v-text="item.date + item.time"
            ></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>
<script>
export default {
  components: {},
  data: () => ({
    items: [
      {
        icon: 'mdi-inbox',
        title: '공지사항',
        sub: '요청된 2022년 급여 계산 작업이 완료되었습니다.',
        date: '2022.03.28',
        time: '14:58',
      },
      {
        icon: 'mdi-star',
        title: '공지사항',
        sub: '요청된 2022년 급여 계산 작업이 완료되었습니다.',
        date: '2022.03.29',
        time: '14:58',
      },
    ],
  }),
};
</script>
